import env from "../utils/env";
import { prepareHttpHeaders } from "../utils/http";

export default function getSettings() {
  return fetch(`${env("BASE_URL")}/websdk_settings`, {
    method: "POST",
    headers: prepareHttpHeaders()
  }).then(res => res.json());
}
